/**
 * Builds a race URL with consistent formatting
 * @param eventUniqueCode - The unique code for the event
 * @param raceId - The race ID
 * @param path - The page path (e.g., '/leaderboard', '/statistics', '/awards')
 * @param search - Query string parameters (should include leading ?)
 * @returns Formatted URL string
 */
export const buildRaceUrl = (
  eventUniqueCode: string,
  raceId: string,
  path: string = '',
  search: string = ''
): string => {
  const basePath = `/events/${encodeURIComponent(eventUniqueCode)}/race/${encodeURIComponent(raceId)}`;

  // Leaderboard is the default route, so strip it from the URL
  const urlPath = path === '/leaderboard' ? '' : path;

  return `${basePath}${urlPath}${search}`;
};

/**
 * Builds an event home URL
 * @param eventUniqueCode - The unique code for the event
 * @param search - Query string parameters (should include leading ?)
 * @returns Formatted URL string
 */
export const buildEventUrl = (eventUniqueCode: string, search: string = ''): string => {
  return `/events/${encodeURIComponent(eventUniqueCode)}${search}`;
};

/**
 * Builds a participant details URL
 * @param eventUniqueCode - The unique code for the event
 * @param raceId - The race ID
 * @param resultCode - The participant result code
 * @param search - Query string parameters (should include leading ?)
 * @returns Formatted URL string
 */
export const buildParticipantUrl = (
  eventUniqueCode: string,
  raceId: string,
  resultCode: string,
  search: string = ''
): string => {
  return `/events/${encodeURIComponent(eventUniqueCode)}/race/${encodeURIComponent(raceId)}/participant/${encodeURIComponent(resultCode)}${search}`;
};
